import { Card, CardContent } from '@/components/ui/card';

const FollowerEmptyState = () => {
  return (
    <Card>
      <CardContent className='flex items-center justify-center py-8'>
        <div className='text-center'>
          <p className='text-muted-foreground'>No followers found</p>
          <p className='text-sm text-muted-foreground'>
            Try adjusting your filters or search query
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default FollowerEmptyState;
